// extracted by mini-css-extract-plugin
export var section = "_2h-1";
export var topNav = "_2h-0";